import React from "react";

interface PropsI {
    id?:string;
    message: string;
    className?: string;
}

const ErrorViewer = ({ message, className, id }: PropsI) => {
    return (
        <div className={`error-message ${className}`} id={id}>
            {message}
        </div>
    );
};

export default ErrorViewer;